import SearchParamsBase from '../../../Elements/SearchParamsBase';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import AuthService from '../../../Services/authService';

export default class ExcelDataExportSearchParams extends SearchParamsBase {
  static saveType = 'ExcelDataExportSearchParams';
  initialize() {
    this.Report = null;
    this.FromDate = new Date(dateTimeHelper.addMonthsToDate(new Date(), -1));
    this.ToDate = new Date();
    this.Office = [...ExcelDataExportSearchParams.getUserOffice()];
    this.Client = null;
    this.Project = null;
  }

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return OfficeHelper.GetDefaultOfficeIds(user.officeId);
  }
}
